import { graphql, useStaticQuery } from 'gatsby';

const useFooterData = () => {
  const data = useStaticQuery(
    graphql`
      query FOOTER_DATA_QUERY {
        markdownRemark(frontmatter: { templateKey: { eq: "footer" } }) {
          frontmatter {
            imagePlayStore {
              childImageSharp {
                fixed(width: 140, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            imageAppStore {
              childImageSharp {
                fixed(width: 140, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            imageBar {
              childImageSharp {
                fluid(maxWidth: 1400, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            facebookUrl
            linkedInUrl
            instagramUrl
            youtubeUrl
            appText
            icon
            copyRight
            info {
              title
              link
            }
          }
        }
      }
    `
  );

  return data.markdownRemark.frontmatter;
};

export default useFooterData;
